import { useSite } from "../context/SiteContext";
import { Reveal, SectionHeader } from "../components/home/Sections";
import { SectionBody } from "../components/RichText";
import { StoreButtons } from "../components/StoreButtons";

export default function FonctionnementPage() {
    const { data } = useSite();
    const hero = data?.sections?.fonctionnement_hero;
    const outro = data?.sections?.fonctionnement_outro;
    const steps = [1, 2, 3, 4, 5, 6, 7, 8].map((n) => data?.sections?.[`step_${n}`]).filter(Boolean);
    return (
        <main className="bg-cream min-h-screen pt-32 pb-24" data-testid="fonctionnement-page">
            <div className="container-bc">
                {(!hero || hero.visible !== false) && (
                    <SectionHeader
                        eyebrow={hero?.eyebrow || "La méthode BODYCOACHIA"}
                        title={hero?.title || ""}
                        subtitle={hero?.subtitle || ""}
                    />
                )}
                <ol className="relative border-l-2 border-gold/40 ml-4 space-y-12 mt-8">
                    {steps.map((s, i) => (
                        <Reveal key={i}>
                            <li className="relative pl-10" data-testid={`fonctionnement-step-${i + 1}`}>
                                <span className="absolute -left-[1.35rem] top-0 w-10 h-10 rounded-full bg-forest text-gold font-mono font-semibold flex items-center justify-center border-2 border-gold">
                                    {String(i + 1).padStart(2, "0")}
                                </span>
                                <h2 className="font-heading font-bold text-forest text-xl sm:text-2xl">{s.title}</h2>
                                <SectionBody sec={s} className="text-pineneedle mt-2 leading-relaxed max-w-2xl" testid={`fonctionnement-step-body-${i + 1}`} />
                            </li>
                        </Reveal>
                    ))}
                </ol>
                {outro && outro.visible !== false && (
                    <Reveal className="mt-16 rounded-3xl bg-forest text-cream p-10" >
                        <div data-testid="fonctionnement-outro">
                            <h2 className="font-heading font-bold text-2xl">{outro.title}</h2>
                            <SectionBody sec={outro} className="text-sage mt-3 leading-relaxed max-w-3xl" testid="fonctionnement-outro-body" />
                            <div className="mt-8">
                                <StoreButtons dark />
                            </div>
                        </div>
                    </Reveal>
                )}
            </div>
        </main>
    );
}
